import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';
import { getFormRoot } from './form-data.utility';
import type { FormlyHookFn } from './formly-hook-fn.type';

const findFieldByKey = (
  fields: FormlyFieldConfig | FormlyFieldConfig[] | undefined,
  key: string
): FormlyFieldConfig | undefined => {
  const candidates = Array.isArray(fields) ? fields : fields ? [fields] : [];

  for (const candidate of candidates) {
    if (candidate.key === key) {
      return candidate;
    }

    const childField = findFieldByKey(candidate.fieldGroup, key);
    if (childField) {
      return childField;
    }
  }

  return undefined;
};

export const refreshDcV2gInverterValidationHook = (
  destroyed$
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    field.formControl?.valueChanges
      .pipe(takeUntil(destroyed$))
      .subscribe(() => {
        const formRoot = getFormRoot(field);
        const equipmentInformationField = findFieldByKey(
          formRoot,
          'equipment_information'
        );
        const repeatField = findFieldByKey(
          equipmentInformationField ?? formRoot,
          'inverters'
        );
        repeatField?.formControl?.updateValueAndValidity();
      });
  };
};
